import { inject, NewInstance } from 'aurelia-framework';
import { PartService } from 'pages/quote-setup/parts/service';
import { PartSizeService } from 'pages/standard-setup/part-sizes/service';
import { CommodityService } from 'pages/system-fields/commodities/service';
import { PlantService } from 'pages/quote-setup/plants/service';
import { PurchasePartTypeService } from 'pages/system-fields/purchase-part-types/service';
import { EventAggregator } from 'aurelia-event-aggregator';
import { DialogController } from 'aurelia-dialog';
import { DialogService } from 'aurelia-dialog';
import { ValidationRules, ValidationController, validateTrigger } from 'aurelia-validation';
import { BootstrapFormRenderer } from 'resources/validation-renderer';
import toastr from 'toastr';

@inject(DialogController, NewInstance.of(ValidationController), PartService, PartSizeService, CommodityService, PlantService, PurchasePartTypeService, EventAggregator, DialogService)
export class PartEditor {
    constructor(controller, validationController, partService, partSizeService, commodityService, plantService, purchasePartTypeService, ea, dialogService) {
        this.controller = controller;
        this.dialogService = dialogService;
        this.partService = partService;
        this.partSizeService = partSizeService;
        this.commodityService = commodityService;
        this.plantService = plantService;
        this.purchasePartTypeService = purchasePartTypeService;
        this.ea = ea;
        this.part = {
            partType: 'MANUFACTURED',
            isWeightBased: false
        };

        this.partTypes = ['MANUFACTURED', 'PURCHASED'];

        this.validationController = validationController;
        this.validationController.validateTrigger = validateTrigger.manual;
        this.validationController.addRenderer(new BootstrapFormRenderer());
        this.rules = ValidationRules
            .ensure('number').required()
            .ensure('name').required()
            .ensure('supplierName').required().when(part => part.partType === 'PURCHASED')
            .ensure('purchaseCost').required().when(part => part.partType === 'PURCHASED')
            .ensure('purchasePartTypeId').required().when(part => part.partType === 'PURCHASED').withMessage('Purchase part type is required')
            .rules;
    }

    attached () {
        this.uxBody.querySelector("#number").focus();
    }

    async activate(model) {
        if (model?.id != null) {
            this.part = await this.partService.getById(model.id);
        }

        if (model?.clonePartId != null) {
            const clonePart = await this.partService.getById(model.clonePartId);
            clonePart.id = undefined;
            this.part = clonePart;
        }
    }

    addPartSize () {
        this.dialogService.open({ viewModel: this.partSizeService.editor });
    }

    addCommodity () {
        this.dialogService.open({ viewModel: this.commodityService.editor });
    }

    addPlant () {
        this.dialogService.open({ viewModel: this.plantService.editor });
    }

    addPurchasePartType () {
        this.dialogService.open({ viewModel: this.purchasePartTypeService.editor });
    }

    async save(addNew) {
        if (this.isRequesting) return;
        this.isRequesting = true;
        const validationResult = await this.validationController.validate();
        if (validationResult.valid) {
            try {
                if (this.part.id) {
                    await this.partService.update(this.part);
                    toastr.success('Part was updated!');
                } else {
                    await this.partService.create(this.part);
                    toastr.success('New part was created!');
                }
                this.ea.publish('parts:updated', this.part);
                if (addNew) {
                    this.part = {
                        partType: 'MANUFACTURED'
                    };
                    this.purcchasePartTypeSelect.clearSelection();
                    this.commoditySelect.clearSelection();
                    this.sizeSelect.clearSelection();
                    this.plantSelect.clearSelection();
                    this.uxBody.querySelector("#number").focus();
                } else {
                    this.controller.ok(this.part);
                }
            } catch {
                this.isRequesting = false;
            }
        }
        this.isRequesting = false;
    }
}
